export function Footer() {
  return (
    <footer className="relative border-t border-border/50 bg-background">
      <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-12">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-display text-[clamp(2rem,4vw,3.5rem)] leading-[0.95] tracking-mega text-bone">
              Crafted in <em className="font-serif-soft italic text-chrome">shadow</em> &amp; light.
            </p>
            <p className="mt-6 max-w-md text-sm text-muted-foreground">
              An AI photoshoot studio for those who want to be seen differently — not polished into perfection, but transformed into cinema.
            </p>
          </div>
          <div className="md:col-span-3 md:col-start-8">
            <p className="text-[11px] uppercase tracking-editorial text-muted-foreground">Studio</p>
            <ul className="mt-4 space-y-2 text-sm text-bone">
              <li><a href="#aesthetics" className="hover:text-chrome">Aesthetics</a></li>
              <li><a href="#process" className="hover:text-chrome">Process</a></li>
              <li><a href="#gallery" className="hover:text-chrome">Gallery</a></li>
              <li><a href="#vision" className="hover:text-chrome">Vision</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-editorial text-muted-foreground">Connect</p>
            <ul className="mt-4 space-y-2 text-sm text-bone">
              <li><a href="#" className="hover:text-chrome">Instagram</a></li>
              <li><a href="#" className="hover:text-chrome">TikTok</a></li>
              <li><a href="#" className="hover:text-chrome">Email</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-border/40 pt-6 text-[11px] uppercase tracking-editorial text-muted-foreground md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Mikazura Studio</p>
          <p>Curated for the beautifully uncommon</p>
        </div>
      </div>
    </footer>
  );
}
